<template>
    <v-card color="#F5F2FB" flat class="rounded-0">
        <v-container class="py-8">
            <!-- ==================== 顶部筛选区（横向） ==================== -->
            <v-card flat class="filter-bar template-panel">
                <!-- 第一行：类别横向选择 -->
                <div class="filter-row">
                    <div class="filter-label">
                        <v-icon color="#7331FF" size="20" class="mr-2">mdi-tune-variant</v-icon>
                        {{ $t('筛选') }}
                    </div>
                    <div class="cat-tabs" ref="catTabs">
                        <span class="cat-tab" :class="{ active: !getparam.themes_tag_id }" @click="changeTag(null)">
                            {{ $t('全部') }}
                        </span>
                        <span class="cat-tab" v-for="item in filteredCats" :key="item.themes_tag_id"
                            :class="{ active: getparam.themes_tag_id == item.themes_tag_id }"
                            @click="changeTag(item)">
                            {{ item.name }}
                        </span>
                    </div>
                </div>

                <!-- 第二行：搜索 + 价格 + 重置 -->
                <div class="filter-row filter-row-2">
                    <div class="search-box">
                        <v-icon size="18" color="#9AA5B5" class="mr-2">mdi-magnify</v-icon>
                        <input type="text" v-model="searchKeyword" :placeholder="$t('搜索模板名称')"
                            class="search-input" @keyup.enter="doSearch()" />
                        <v-btn icon small color="#7331FF" @click="doSearch()">
                            <v-icon size="18">mdi-arrow-right</v-icon>
                        </v-btn>
                    </div>

                    <div class="price-box" v-if="shopInfo">
                        <span class="price-label">{{ $t('价格') }}</span>
                        <v-text-field solo flat dense hide-details :prefix="shopInfo.symbol"
                            background-color="#F7F7F7" v-model="getparam.start_price" placeholder="最低"
                            class="price-input"></v-text-field>
                        <span class="price-line">—</span>
                        <v-text-field solo flat dense hide-details :prefix="shopInfo.symbol"
                            background-color="#F7F7F7" v-model="getparam.end_price" placeholder="最高"
                            class="price-input"></v-text-field>
                        <v-btn depressed height="36" color="#7331FF" dark class="price-apply" @click="getlist()">
                            <v-icon size="16">mdi-check</v-icon>
                        </v-btn>
                    </div>

                    <div class="filter-actions">
                        <span class="active-count" v-if="activeCount">{{ activeCount }} {{ $t('个筛选') }}</span>
                        <v-btn text rounded small color="#8A96A8" @click="closeTag()">
                            <v-icon small class="mr-1">mdi-refresh</v-icon>
                            {{ $t('重置') }}
                        </v-btn>
                    </div>
                </div>
            </v-card>

            <!-- ==================== 列表头 ==================== -->
            <div class="list-head mt-6">
                <p class="list-title mb-0">{{ selectTag || $t('全部模板') }}</p>
                <span class="list-count">{{ totalCount }} {{ $t('个模板') }}</span>
            </div>

            <!-- ==================== 卡片列表（4 列 9:16） ==================== -->
            <div class="list-grid" v-if="mobanlist.length > 0">
                <div class="t-card" v-for="n in mobanlist" :key="cardKey(n)" @click="goDetail(n)">
                    <div class="t-cover">
                        <div class="cover-box">
                            <v-img :src="n.cover_img" alt="" class="cover-img" cover></v-img>
                        </div>
                        <div class="t-preview">
                            <v-btn color="#7331FF" dark rounded>
                                <v-icon small class="mr-1">mdi-eye-outline</v-icon>
                                {{ $t('查看模板设计') }}
                            </v-btn>
                        </div>
                        <span class="free-tag" v-if="!n.price || n.price == 0">{{ $t('免费') }}</span>
                        <v-img v-if="n.is_buy == 1" src="@/assets/images/template/icon-buyed.png" alt=""
                            class="buyed-badge" width="36" height="40">
                            <span class="buyed-text">buyed</span>
                        </v-img>
                    </div>
                    <div class="t-info">
                        <span class="t-name">{{ n.name }}</span>
                        <span class="t-price" v-if="n.price && n.price != 0">{{ n.symbol }}<b>{{ n.price }}</b></span>
                        <span class="t-price free-text" v-else>{{ $t('免费') }}</span>
                    </div>
                </div>
            </div>

            <!-- 空状态 -->
            <div class="empty-state" v-else>
                <img src="@/assets/images/template/no-buyed.png" alt="" class="empty-img">
                <p class="grey--text">{{ $t('没有结果') }}</p>
            </div>

            <!-- 分页 -->
            <div class="text-center mt-8" v-if="pageTotal > 0">
                <v-pagination v-model="getparam.current_page" :length="pageTotal" total-visible="5"
                    color="#7331FF" @input="getlist()"></v-pagination>
            </div>
        </v-container>
    </v-card>
</template>
<script>
export default {
    data() {
        return {
            catelist: [],
            selectedItem: '',
            selectTag: '',
            searchKeyword: '',
            getparam: {
                current_page: 1,
                page_number: 24,
                start_price: '',
                end_price: '',
                keyword: ''
            },
            pageTotal: 1,
            mobanlist: [],
            totalCount: 0,
            shopInfo: null
        }
    },
    computed: {
        // 类别过滤（本地搜索词过滤类别）
        filteredCats() {
            if (!this.searchKeyword.trim()) return this.catelist;
            const kw = this.searchKeyword.trim().toLowerCase();
            return this.catelist.filter(c => c.name.toLowerCase().includes(kw));
        },
        // 已选筛选数量
        activeCount() {
            let n = 0;
            if (this.getparam.themes_tag_id) n++;
            if (this.getparam.start_price) n++;
            if (this.getparam.end_price) n++;
            if (this.getparam.keyword) n++;
            return n;
        }
    },
    mounted() {
        this.searchKeyword = this.$route.query.keyword || '';
        this.getparam.keyword = this.$route.query.keyword || '';
        this.getlist();
        this.gettaglist();
        this.shopInfo = JSON.parse(localStorage.getItem('DROPSHOPINFO'))
    },
    methods: {
        getlist() {
            this.$api.template.list(this.getparam).then(res => {
                if (res.status) {
                    this.mobanlist = res.data.records;
                    this.totalCount = parseInt(res.data.total) || 0;
                    this.pageTotal = Math.ceil(
                        parseInt(res.data.total) / this.getparam.page_number
                    );
                }
            });
        },
        gettaglist() {
            this.$api.template.tag_list().then(res => {
                if (res.status) {
                    this.catelist = res.data;
                }
            });
        },
        changeTag(item) {
            if (!item) {
                // 全部
                this.selectTag = '';
                delete this.getparam.themes_tag_id;
            } else {
                this.selectTag = item.name;
                this.getparam.themes_tag_id = item.themes_tag_id;
            }
            this.getparam.current_page = 1;
            this.getlist();
        },
        doSearch() {
            this.getparam.keyword = this.searchKeyword.trim();
            this.getparam.current_page = 1;
            this.getlist();
        },
        closeTag() {
            this.selectTag = '';
            this.searchKeyword = '';
            this.getparam.keyword = '';
            this.getparam.start_price = '';
            this.getparam.end_price = '';
            this.getparam.current_page = 1;
            delete this.getparam.themes_tag_id;
            this.getlist();
        },
        // 官方模板 themes_id，店主发布的模板 custom_themes_id（themes_id 恒为 0）
        cardKey(n) {
            return n && n.source === 'custom' ? 'c' + n.custom_themes_id : 'o' + (n ? n.themes_id : '');
        },
        goDetail(n) {
            if (n && n.source === 'custom') {
                this.$router.push('/template-detail?custom_themes_id=' + n.custom_themes_id);
                return;
            }
            this.$router.push('/template-detail?themes_id=' + n.themes_id);
        }
    }
}
</script>
<style lang="scss" scoped>
.template-panel {
    background: #fff;
    border: 1px solid #EEF1F5;
    border-radius: 14px;
    box-shadow: 0 4px 16px rgba(15, 52, 96, 0.05);
}

/* ===================== 封面图 9:16 约束 ===================== */
.cover-box {
    position: relative;
    width: 100%;
    padding-top: 177.78%; /* 9:16 */
    overflow: hidden;

    .cover-img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
}

/* ===================== 顶部筛选区 ===================== */
.filter-bar {
    padding: 18px 24px;

    .filter-row {
        display: flex;
        align-items: center;
        gap: 16px;

        & + .filter-row {
            margin-top: 14px;
            padding-top: 14px;
            border-top: 1px solid #F0F2F5;
        }
    }

    .filter-label {
        font-size: 14px;
        font-weight: 700;
        color: #242939;
        flex-shrink: 0;
        display: flex;
        align-items: center;
    }

    /* 类别横向滚动 */
    .cat-tabs {
        display: flex;
        gap: 8px;
        overflow-x: auto;
        padding-bottom: 4px;
        scrollbar-width: thin;

        &::-webkit-scrollbar {
            height: 4px;
        }

        &::-webkit-scrollbar-thumb {
            background: #E0E6EE;
            border-radius: 4px;
        }
    }

    .cat-tab {
        flex-shrink: 0;
        padding: 6px 14px;
        border-radius: 18px;
        font-size: 13px;
        color: #4A5568;
        background: #F6F8FC;
        border: 1px solid #EEF1F5;
        cursor: pointer;
        transition: all 0.15s;
        white-space: nowrap;

        &:hover {
            color: #7331FF;
            border-color: #C9B8F2;
        }

        &.active {
            background: #7331FF;
            color: #fff;
            border-color: #7331FF;
            font-weight: 600;
        }
    }

    /* 第二行：搜索 + 价格 + 重置 */
    .search-box {
        display: flex;
        align-items: center;
        background: #F6F8FC;
        border: 1px solid #EEF1F5;
        border-radius: 10px;
        padding: 4px 6px 4px 12px;
        width: 260px;
        flex-shrink: 0;
        transition: border-color 0.2s;

        &:focus-within {
            border-color: #7331FF;
            background: #fff;
        }

        .search-input {
            flex: 1;
            border: none;
            outline: none;
            background: transparent;
            font-size: 13px;
            color: #242939;
            height: 28px;

            &::placeholder {
                color: #B4BDC9;
            }
        }
    }

    .price-box {
        display: flex;
        align-items: center;
        gap: 6px;
        flex-shrink: 0;

        .price-label {
            font-size: 13px;
            color: #4A5568;
            margin-right: 4px;
        }

        .price-input {
            width: 90px;
            font-size: 13px;
        }

        .price-line {
            color: #9AA5B5;
        }

        .price-apply {
            border-radius: 8px;
        }
    }

    .filter-actions {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-left: auto;

        .active-count {
            font-size: 12px;
            color: #7331FF;
            background: rgba(115, 49, 255, 0.08);
            padding: 3px 10px;
            border-radius: 14px;
        }
    }
}

@media (max-width: 960px) {
    .filter-bar {
        .filter-row {
            flex-wrap: wrap;
        }

        .filter-row-2 {
            gap: 12px;
        }

        .search-box {
            width: 100%;
        }

        .filter-actions {
            margin-left: 0;
        }
    }
}

/* ===================== 列表头 ===================== */
.list-head {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .list-title {
        font-size: 20px;
        font-weight: 700;
        color: #0F3460;
    }

    .list-count {
        font-size: 13px;
        color: #8A96A8;
        background: #fff;
        border: 1px solid #EEF1F5;
        padding: 4px 12px;
        border-radius: 16px;
    }
}

/* ===================== 卡片网格 ===================== */
.list-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 24px;
    margin-top: 20px;

    @media (max-width: 1200px) {
        grid-template-columns: repeat(3, 1fr);
    }

    @media (max-width: 960px) {
        grid-template-columns: repeat(3, 1fr);
    }

    @media (max-width: 700px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 480px) {
        grid-template-columns: 1fr;
    }
}

.t-card {
    cursor: pointer;
    border-radius: 14px;
    overflow: hidden;
    background: #fff;
    border: 1px solid #EEF1F5;
    transition: box-shadow 0.25s, transform 0.25s;

    &:hover {
        transform: translateY(-4px);
        box-shadow: 0 16px 36px rgba(15, 52, 96, 0.12);

        .cover-img {
            transform: scale(1.04);
        }

        .t-preview {
            opacity: 1;
        }
    }
}

.t-cover {
    position: relative;
    margin: 8px;

    .cover-box {
        border-radius: 8px;
    }

    .cover-img {
        border-radius: 8px;
        transition: transform 0.4s ease;
    }

    .t-preview {
        position: absolute;
        inset: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(15, 52, 96, 0.22);
        opacity: 0;
        transition: opacity 0.25s;
        z-index: 2;
        border-radius: 8px;
    }

    .free-tag {
        position: absolute;
        top: 12px;
        left: 12px;
        background: rgba(255, 255, 255, 0.94);
        color: #09bb07;
        font-size: 12px;
        font-weight: 600;
        padding: 3px 10px;
        border-radius: 20px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        z-index: 3;
    }

    .buyed-badge {
        position: absolute;
        top: 8px;
        left: 8px;
        z-index: 3;

        .buyed-text {
            bottom: 5px;
            position: absolute;
            left: 0;
            width: 100%;
            text-align: center;
            right: 0;
            color: #fff;
            transform: scale(0.75);
        }
    }
}

.t-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 6px 16px 16px;

    .t-name {
        font-size: 14px;
        font-weight: 600;
        color: #242939;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-right: 12px;
    }

    .t-price {
        font-size: 14px;
        color: #7331FF;
        font-weight: 600;
        flex-shrink: 0;

        b {
            font-size: 16px;
        }

        &.free-text {
            color: #09bb07;
        }
    }
}

/* ===================== 空状态 ===================== */
.empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 48px 0;
    background: #fff;
    border: 1px solid #EEF1F5;
    border-radius: 14px;
    margin-top: 20px;

    .empty-img {
        width: 120px;
        opacity: 0.7;
    }

    p {
        margin: 12px 0 0;
        font-size: 14px;
    }
}
</style>
